import React from 'react'
import { CreateGradeHooks, validate } from '.'
import { Alert } from 'components'
import { WrapCreateAffiliation } from './Style'
import { Form } from 'components/Form'
import { useSelector } from 'react-redux'
import grade from 'pages/School/CreateGrade/hooks'

const CreateTestTaker = () => {
    const formName = "createGrade"
    const title = "הוספת שכבה"
    const { testTaker } = useSelector(state => state.testTaker)
    const { headerFilters } = useSelector(state => state.header)

    const createGrade = grade.useCreateGrade()
    const setAlert = CreateGradeHooks.useAlert()
    const submitBtns = CreateGradeHooks.useSubmitBtns()
    const fields = CreateGradeHooks.useFormFields()

    return (
        <Alert
            systemUI
            title={title}
            footerActions={submitBtns}
            handleAlert={() => setAlert(false)}
        >
            <Form
                form={formName}
                title={null}
                validations={(values) => validate(values, testTaker)}
                fields={fields}
                csswrap={WrapCreateAffiliation}
                // submitBtns={submitBtns}
                submit={createGrade}
                initialValues={headerFilters}
            />
        </Alert>
    )
}

export default CreateTestTaker